import React from 'react'
import { withRouter, Switch, Redirect } from 'react-router-dom'
import LoadableComponent from '../../utils/LoadableComponent'
import PrivateRoute from '../PrivateRoute'

const Home = LoadableComponent(()=>import('../../routes/Home/index'))  //参数一定要是函数，否则不会懒加载，只会代码拆分

//指标详情


const DbEventMetricDetails = LoadableComponent(()=>{
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    return import('../../routes/Metrics/mobile/DbEventMetricDetails')
  }else{
    return import('../../routes/Metrics/DbEventMetricDetails')
  }
})
const LogEventMetricDetails = LoadableComponent(() =>{
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    return import('../../routes/Metrics/mobile/LogEventMetricDetails')
  }else{
    return import('../../routes/Metrics/LogEventMetricDetails')
  }
})

//未处理报警信息
const UnhandledAlertMsg= LoadableComponent(()=>import('../../routes/Alert/unhandled-alerts/UnhandledAlertList'))
const UnhandledAlertDetail= LoadableComponent(()=>{
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    return import('../../routes/Alert/unhandled-alerts/mobile/UnhandledAlertDetail')
  }else{
    return import('../../routes/Alert/unhandled-alerts/UnhandledAlertDetail')
  }
})
//已处理报警信息
const HandledAlertMsg= LoadableComponent(()=>import('../../routes/Alert/handled-alerts/HandledAlertList'))
const HandledAlertDetail= LoadableComponent(()=>import('../../routes/Alert/handled-alerts/HandledAlertDetail'))


//报警规则
const AlertRules = LoadableComponent(()=>import('../../routes/AlertRules/ThresholdRuleList'))
const AddDbEventThresholdRule = LoadableComponent(()=>import('../../routes/AlertRules/AddDbEventThresholdRule'))
const AddLogEventThresholdRule = LoadableComponent(() => import('../../routes/AlertRules/AddLogEventThresholdRule'))
const EditDbEventThresholdRule = LoadableComponent(()=>import('../../routes/AlertRules/EditDbEventThresholdRule'))
const EditLogEventThresholdRule = LoadableComponent(() => import('../../routes/AlertRules/EditLogEventThresholdRule'))
const ViewThresholdRule = LoadableComponent(()=>import('../../routes/AlertRules/ViewThresholdRule'))

//订阅报警
const GroupList = LoadableComponent(()=>import('../../routes/Subscription/GroupList'))

//监控指标图表
const MetricDashboard = LoadableComponent(()=>import('../../routes/MonitorDashBoard/MetricDashboard/metricDashBoard'))

// 用户添加页面
const UserAdd = LoadableComponent(()=>import('../../routes/UserAdd/userAdd'))

// 用户信息页面
const UserInfo = LoadableComponent(()=>import('../../routes/UserInfo/userInfo'))

// 用户验证页面
const UserCheck = LoadableComponent(()=>import('../../routes/Login/index'))

/**
 * 路径映射
 */


@withRouter
class ContentMain extends React.Component {
  render () {

    return (
      <div style={{padding: 16, position: 'relative'}}>
        <Switch>
          <PrivateRoute exact path='/home' component={Home}/>
          <PrivateRoute exact path='/home/login' component={UserCheck}/>
          <PrivateRoute exact path='/home/alerts/rules' component={AlertRules}/>
          <PrivateRoute exact path='/home/alerts/rules/add/dbevent' component={AddDbEventThresholdRule}/>
          <PrivateRoute exact path='/home/alerts/rules/add/logevent' component={AddLogEventThresholdRule}/>
          <PrivateRoute exact path='/home/alerts/rules/edit/db_event/:alertname/:metricname' component={EditDbEventThresholdRule}/>
          <PrivateRoute exact path='/home/alerts/rules/edit/log_event/:alertname/:metricname' component={EditLogEventThresholdRule}/>
          <PrivateRoute exact path='/home/alerts/rules/check/:alertname' component={ViewThresholdRule}/>

          <PrivateRoute exact path='/home/alerts/metrics/details/db_event/:metricname' component={DbEventMetricDetails}/>
          <PrivateRoute exact path='/home/alerts/metrics/details/log_event/:metricname' component={LogEventMetricDetails}/>
          <PrivateRoute exact path='/home/alerts/metrics/details/log_event/:metricname/:timestamp' component={LogEventMetricDetails}/>


          <PrivateRoute exact path='/home/alerts/unhandled-alerts' component={UnhandledAlertMsg}/>
          <PrivateRoute exact path='/home/alerts/unhandled-alerts/:id/:timestamp/detail' component={UnhandledAlertDetail}/>
          <PrivateRoute exact path='/home/alerts/unhandled-alerts/:id/detail' component={UnhandledAlertDetail}/>
          <PrivateRoute exact path='/home/alerts/handled-alerts' component={HandledAlertMsg}/>
          <PrivateRoute exact path='/home/alerts/handled-alerts/*/detail' component={HandledAlertDetail}/>
     


          <PrivateRoute exact path='/home/alerts/subscribing' component={GroupList}/>

          <PrivateRoute exact path='/home/monitor/dashboard/metric' component={MetricDashboard}/>

          <PrivateRoute exact path='/home/users' component={UserInfo}/>

          <PrivateRoute exact path='/home/userAdd' component={UserAdd}/>

          <Redirect exact from='/' to='/home'/>
        </Switch>
      </div>
    )
  }
}

export default ContentMain


// WEBPACK FOOTER //
// ./src/components/ContentMain/index.js